import { bitcoin, bitcoinTestnet } from '@reown/appkit/networks';
import { SatsConnectConnector } from './SatsConnectConnector.js';
export class LeatherConnector extends SatsConnectConnector {
    constructor({ connector }) {
        if (connector.wallet.id !== LeatherConnector.ProviderId) {
            throw new Error('LeatherConnector: wallet must be a LeatherProvider');
        }
        super({
            provider: connector.wallet,
            requestedChains: connector.requestedChains,
            getActiveNetwork: connector.getActiveNetwork
        });
    }
    get imageUrl() {
        return this.wallet?.icon?.replace('data:image/svg', 'data:image/svg+xml');
    }
    async getAccountAddresses() {
        // Keep the connected accounts in memory to avoid repeated requests because Leather doesn't have a connect method
        if (this.connectedAccounts) {
            return this.connectedAccounts;
        }
        this.connectedAccounts = await super.getAccountAddresses();
        return this.connectedAccounts;
    }
    disconnect() {
        // Leather doesn't have disconnect method
        this.connectedAccounts = undefined;
        return Promise.resolve();
    }
    async sendTransfer({ amount, recipient }) {
        const params = {
            address: recipient,
            amount
        };
        const res = await this.internalRequest('sendTransfer', 
        // @ts-expect-error - expected LeatherWallet params don't match sats-connect
        params);
        return res.txid;
    }
    async signPSBT({ psbt, broadcast = false }) {
        const params = {
            hex: Buffer.from(psbt, 'base64').toString('hex'),
            network: this.getNetwork(),
            broadcast
        };
        // @ts-expect-error - expected LeatherWallet params don't match sats-connect
        const res = await this.internalRequest('signPsbt', params);
        return {
            psbt: Buffer.from(res.hex, 'hex').toString('base64'),
            txid: res.txid
        };
    }
    getNetwork() {
        const activeCaipNetwork = this.getActiveNetwork();
        switch (activeCaipNetwork?.caipNetworkId) {
            case bitcoin.caipNetworkId:
                return 'mainnet';
            case bitcoinTestnet.caipNetworkId:
                return 'testnet';
            default:
                throw new Error('LeatherConnector: unsupported network');
        }
    }
}
LeatherConnector.ProviderId = 'LeatherProvider';
//# sourceMappingURL=LeatherConnector.js.map